/* IZU Paros theme — vanilla JS, no dependencies.
   Cart uses Shopify's Ajax Cart API (/cart.js, /cart/add.js, /cart/change.js). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = s => String(s == null ? "" : s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const body = document.body;

  // ---------- Cart drawer "Your Bag" (Ajax API) ----------
  const cartEl = $("#cart"), scrim = $("#scrim");
  let cart = null, lastCount = null, busy = false;
  const money = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: "currency", currency: (cart && cart.currency) || undefined }).format(cents / 100).replace(/[.,]00(?=\D*$)/, ""); }
    catch { return (cents / 100).toFixed(2); }
  };
  const json = (url, opts) => fetch(url, Object.assign({ headers: { "Content-Type": "application/json", Accept: "application/json" } }, opts)).then(r => r.json());
  const sized = (url, w) => url ? url + (url.includes("?") ? "&" : "?") + "width=" + w : "";
  const say = msg => { const s = $("#cartStatus"); if (s) { s.textContent = ""; setTimeout(() => { s.textContent = msg; }, 60); } };
  function cartError(msg) {
    const el = $("#cartError"); if (!el) return;
    el.textContent = msg || ""; el.hidden = !msg;
  }

  function renderShipping() {
    const box = $("#cartShip"); if (!box || !cartEl) return;
    const th = Number(cartEl.dataset.freeThreshold) || 0, where = cartEl.dataset.freeWhere ? " " + cartEl.dataset.freeWhere : "";
    // Only in the shop's own currency: the threshold is set in it, and converted prices would make the maths wrong.
    if (!th || !cart || !cart.item_count || (cartEl.dataset.shopCurrency && cart.currency !== cartEl.dataset.shopCurrency)) { box.hidden = true; return; }
    const left = th - cart.total_price;
    $("#cartShipText").textContent = left > 0 ? `${money(left)} away from complimentary shipping${where}.` : `Your order ships complimentary${where}.`;
    $("#cartShipFill").style.transform = `scaleX(${Math.min(1, cart.total_price / th)})`;
    box.classList.toggle("is-done", left <= 0);
    box.hidden = false;
  }

  function renderCart() {
    if (!cart) return;
    const n = cart.item_count;
    const badge = $("#cartCount");
    if (badge) {
      badge.textContent = n; badge.hidden = n === 0;
      if (lastCount !== null && n !== lastCount && n > 0) { badge.classList.remove("is-pop"); void badge.offsetWidth; badge.classList.add("is-pop"); }
      if (!badge._popBound) { badge._popBound = true; badge.addEventListener("animationend", () => badge.classList.remove("is-pop")); }
    }
    lastCount = n;
    $("#cartOpen")?.setAttribute("aria-label", `Open bag, ${n} item${n === 1 ? "" : "s"}`);
    $("#cartTotalQty").textContent = n;
    $("#cartSubtotal").textContent = money(cart.total_price);
    cartEl?.classList.toggle("is-empty", n === 0);
    const note = $("#cartNote");
    if (note && document.activeElement !== note) note.value = cart.note || "";
    renderShipping();
    const shopUrl = (cartEl && cartEl.dataset.shopUrl) || "/collections/all";
    $("#cartLines").innerHTML = n === 0
      ? `<li class="cart__empty">
          <p class="cart__empty-title">Your bag is empty, for now.</p>
          <p class="cart__empty-text">Start with something light for long island evenings.</p>
          <a class="more-link cart__empty-link" href="${esc(shopUrl)}">Shop now <span aria-hidden="true">&rarr;</span></a>
        </li>`
      : cart.items.map((it, i) => {
          const opts = (it.options_with_values || []).filter(o => o.name !== "Title" && o.value !== "Default Title").map(o => `${esc(o.name)}: ${esc(o.value)}`).join(" · ");
          const title = esc(it.product_title);
          const sized = (it.options_with_values || []).some(o => /^size$/i.test(o.name) && !/one size/i.test(o.value));
          const guideUrl = (cartEl && cartEl.dataset.sizeGuide) || "/pages/size-care-guide";
          return `<li class="line" data-line="${i + 1}" data-qty="${it.quantity}">
            <a class="line__img" href="${esc(it.url)}" tabindex="-1" aria-hidden="true">${it.image ? `<img src="${esc(sized(it.image, 240))}" alt="" width="120" height="160" loading="lazy">` : ""}</a>
            <div class="line__body">
              <a class="line__name product-title product-title--small" href="${esc(it.url)}">${title}</a>
              ${opts ? `<p class="line__opt">${opts}</p>` : ""}
              ${sized ? `<a class="line__guide" href="${esc(guideUrl)}#sizing">Unsure of fit? Size guide</a>` : ""}
              <div class="line__row">
                <div class="qty" role="group" aria-label="Quantity of ${title}">
                  <button type="button" data-q="-1" aria-label="${it.quantity === 1 ? "Remove" : "Decrease quantity of"} ${title}">−</button>
                  <span aria-live="off">${it.quantity}</span>
                  <button type="button" data-q="1" aria-label="Increase quantity of ${title}">+</button>
                </div>
                <span class="line__price">${it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s> ` : ""}${money(it.final_line_price)}</span>
              </div>
              <button type="button" class="line__rm" data-q="remove">Remove<span class="sr"> ${title}</span></button>
            </div>
          </li>`;
        }).join("");
  }
  const refreshCart = () => json("/cart.js").then(c => { cart = c; renderCart(); });
  const addToCart = (id, quantity = 1) => json("/cart/add.js", { method: "POST", body: JSON.stringify({ items: [{ id: Number(id), quantity }] }) })
    .then(res => { if (res.status && res.status !== 200 && res.description) throw new Error(res.description); cartError(""); return refreshCart(); });
  const changeLine = (line, quantity) => json("/cart/change.js", { method: "POST", body: JSON.stringify({ line, quantity }) })
    .then(c => { if (c.status && c.description) throw new Error(c.description); cart = c; renderCart(); cartError(""); say(quantity === 0 ? "Removed from your bag." : "Your bag was updated."); });

  let lastFocus = null;
  function setCart(open) {
    if (!cartEl) return;
    if (open) lastFocus = document.activeElement;
    cartEl.style.transform = "";
    cartEl.classList.toggle("open", open);
    cartEl.setAttribute("aria-hidden", !open);
    body.classList.toggle("locked", open);
    if (open) { scrim.hidden = false; requestAnimationFrame(() => scrim.classList.add("show")); $("#cartClose").focus(); }
    else { scrim.classList.remove("show"); setTimeout(() => { scrim.hidden = true; }, 300); saveNote(); lastFocus && lastFocus.focus(); }
  }
  // Open + focus happen synchronously in the click handler (focus() calls made after an await can be silently
  // dropped once the click's user-activation window has expired); the cart contents refresh in parallel.
  $("#cartOpen")?.addEventListener("click", () => { setCart(true); refreshCart(); });
  document.addEventListener("izu:cart-changed", () => { refreshCart(); });
  document.addEventListener("izu:cart-open", () => { setCart(true); refreshCart(); });
  $("#cartClose")?.addEventListener("click", () => setCart(false));
  scrim?.addEventListener("click", () => setCart(false));
  // "View bag" links open the drawer (the link still goes to /cart when JavaScript is off); Tab stays inside the open drawer
  document.addEventListener("click", e => { if (e.target.closest("[data-pd-viewbag]") && cartEl) { e.preventDefault(); setCart(true); refreshCart(); } });
  cartEl?.addEventListener("keydown", e => {
    if (e.key !== "Tab") return;
    const f = Array.from(cartEl.querySelectorAll("button, a[href], input, textarea, summary, iframe")).filter(x => !x.disabled && x.offsetParent !== null && x.tabIndex !== -1);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  $("#cartLines")?.addEventListener("click", e => {
    const b = e.target.closest("[data-q]"), li = e.target.closest(".line");
    if (!b || !li || busy) return;
    const qty = Number(li.dataset.qty);
    busy = true; li.classList.add("is-busy");
    changeLine(Number(li.dataset.line), b.dataset.q === "remove" ? 0 : Math.max(0, qty + Number(b.dataset.q)))
      .catch(err => { cartError(err.message || "Something went wrong. Please try again."); li.classList.remove("is-busy"); })
      .finally(() => { busy = false; });
  });

  // Gift note: saved to the cart as the visitor types (debounced), and always before leaving for checkout.
  const noteEl = $("#cartNote");
  let noteTimer = null, noteSaved = noteEl ? noteEl.value : "";
  function saveNote() {
    clearTimeout(noteTimer);
    if (!noteEl || noteEl.value === noteSaved) return Promise.resolve();
    const v = noteEl.value;
    return json("/cart/update.js", { method: "POST", body: JSON.stringify({ note: v }) }).then(c => { noteSaved = v; if (c && c.token) cart = c; }).catch(() => {});
  }
  noteEl?.addEventListener("input", () => { clearTimeout(noteTimer); noteTimer = setTimeout(saveNote, 600); });
  $("#checkout")?.addEventListener("click", e => {
    e.preventDefault();
    const a = e.currentTarget; a.setAttribute("aria-busy", "true");
    saveNote().finally(() => { window.location.href = "/checkout"; });
  });

  // Swipe the drawer away to the right (touch screens), like the sheets elsewhere on the site.
  if (cartEl) {
    let sx = null, sy = 0, dx = 0, horizontal = null;
    cartEl.addEventListener("touchstart", e => { if (!cartEl.classList.contains("open") || e.target.closest("textarea, input, iframe")) return; sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; horizontal = null; }, { passive: true });
    cartEl.addEventListener("touchmove", e => {
      if (sx === null) return;
      const mx = e.touches[0].clientX - sx, my = e.touches[0].clientY - sy;
      if (horizontal === null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) horizontal = Math.abs(mx) > Math.abs(my);
      if (!horizontal) return;
      dx = Math.max(0, mx);
      cartEl.style.transition = "none"; cartEl.style.transform = `translateX(${dx}px)`;
    }, { passive: true });
    cartEl.addEventListener("touchend", () => {
      if (sx === null) return;
      sx = null; cartEl.style.transition = "";
      if (horizontal && dx > 90) setCart(false); else cartEl.style.transform = "";
    });
  }

  // ---------- Product cards: swatches + add to bag ----------
  document.addEventListener("click", e => {
    const card = e.target.closest(".card");
    if (!card) return;
    const sw = e.target.closest(".swatch");
    if (sw) {
      $$(".swatch", card).forEach(s => s.setAttribute("aria-pressed", s === sw));
      if (sw.dataset.variantId) card.dataset.variantId = sw.dataset.variantId;
      const img = $("[data-card-image]", card);
      if (img && sw.dataset.image) { img.removeAttribute("srcset"); img.src = sw.dataset.image; }
      return;
    }
    if (e.target.closest("[data-add-to-cart]")) {
      e.preventDefault();
      const id = card.dataset.variantId;
      if (id) addToCart(id).then(() => setCart(true)).catch(err => { cartError(err.message); setCart(true); refreshCart(); });
    }
  });

  // Card size selector (e.g. the Lookbook's Shop the look sheet): the chosen variant is the one Add to bag adds
  document.addEventListener("change", e => {
    const sel = e.target.closest && e.target.closest("[data-card-variant]");
    if (!sel) return;
    const card = sel.closest(".card"); if (card) card.dataset.variantId = sel.value;
  });

  // Product page: add via Ajax, variant select reloads with ?variant=
  $("#product-form")?.addEventListener("submit", e => {
    e.preventDefault();
    addToCart(new FormData(e.target).get("id")).then(() => setCart(true)).catch(err => { cartError(err.message); setCart(true); refreshCart(); });
  });
  $("#variant-select")?.addEventListener("change", e => { window.location.search = `?variant=${e.target.value}`; });

  // ---------- Product carousels (arrows + edge states) ----------
  $$(".carousel").forEach(wrap => {
    const rail = $(".rail", wrap);
    if (!rail) return;
    const prev = $('.arrow[data-dir="-1"]', wrap), next = $('.arrow[data-dir="1"]', wrap);
    const sync = () => {
      prev.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    [prev, next].forEach(a => a.addEventListener("click", () => rail.scrollBy({ left: Number(a.dataset.dir) * rail.clientWidth * 0.8, behavior: "smooth" })));
    // Phones: small dots under the rail show where you are (decorative; the cards themselves are the content)
    const dotsEl = $("[data-muses-dots]", wrap), cards = $(".muses__card", rail);
    if (dotsEl && cards.length > 1) {
      dotsEl.innerHTML = cards.map(() => "<span></span>").join("");
      const dots = $("span", dotsEl);
      const mark = () => {
        const mid = rail.scrollLeft + rail.clientWidth / 2;
        let on = 0;
        cards.forEach((c, i) => { if (c.offsetLeft <= mid) on = i; });
        dots.forEach((d, i) => d.classList.toggle("is-on", i === on));
      };
      rail.addEventListener("scroll", mark, { passive: true });
      mark();
    }
    rail.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  });

  // ---------- IZU Muses rail (arrows + edge states; same pattern as the product carousels above) ----------
  $$(".muses__viewport").forEach(wrap => {
    const rail = $(".muses__rail", wrap);
    if (!rail) return;
    const prev = $('.arrow[data-dir="-1"]', wrap), next = $('.arrow[data-dir="1"]', wrap);
    const sync = () => {
      prev.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    [prev, next].forEach(a => a.addEventListener("click", () => rail.scrollBy({ left: Number(a.dataset.dir) * rail.clientWidth * 0.8, behavior: "smooth" })));
    rail.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  });

  // ---------- Contextual back button: a real link always works; use real in-site history when we have it ----------
  const backBtn = $("[data-back]");
  backBtn?.addEventListener("click", e => {
    let sameOrigin = false;
    try { sameOrigin = document.referrer && new URL(document.referrer).origin === location.origin; } catch (err) { /* no referrer */ }
    if (sameOrigin && history.length > 1) { e.preventDefault(); history.back(); }
  });

  // ---------- Mobile menu ----------
  const burger = $("#burger"), menu = $("#menu");
  function setMenu(open) {
    if (!burger || !menu) return;
    burger.setAttribute("aria-expanded", open);
    burger.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    menu.classList.toggle("open", open);
    menu.setAttribute("aria-hidden", !open);
    const menuScrim = $("#menuScrim"); if (menuScrim) menuScrim.classList.toggle("show", open);
    if (!open) document.dispatchEvent(new CustomEvent("izu:menu-closed"));
    body.classList.toggle("locked", open || (cartEl && cartEl.classList.contains("open")));
  }
  burger?.addEventListener("click", () => setMenu(burger.getAttribute("aria-expanded") !== "true"));
  menu?.addEventListener("click", e => { if (e.target.closest("a")) setMenu(false); });
  document.addEventListener("click", e => { if (menu && menu.classList.contains("open") && !e.target.closest("#menu") && !e.target.closest("#burger")) setMenu(false); });
  document.addEventListener("keydown", e => {
    if (e.key !== "Escape") return;
    setMenu(false);
    if (cartEl && cartEl.classList.contains("open")) setCart(false);
  });

  // ---------- Scroll reveal ----------
  const io = "IntersectionObserver" in window
    ? new IntersectionObserver(entries => entries.forEach(en => {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      }), { threshold: 0, rootMargin: "0px 0px 300px 0px" })
    : null;
  $$(".reveal").forEach(el => io ? io.observe(el) : el.classList.add("in"));
  // Failsafe: if the observer is slow or never fires, anything on screen after 3s is shown
  setTimeout(() => $$(".reveal:not(.in)").forEach(el => { if (el.getBoundingClientRect().top < window.innerHeight * 1.2) el.classList.add("in"); }), 3000);

  // ---------- Header: always sticky, never hides; settles into a compact/glassy state once scrolled ----------
  const nav = $("#nav");
  if (nav) {
    const update = () => { nav.classList.toggle("is-scrolled", window.scrollY > 24); };
    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  // ---------- Hero scroll cue (mobile): tap scrolls to the next section; fades out after 40px ----------
  (() => {
    const hero = $(".hero"), cue = hero && $(".hero__cue", hero);
    if (!cue) return;
    cue.addEventListener("click", () => {
      const next = (hero.closest(".shopify-section") || hero).nextElementSibling;
      if (!next) return;
      const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
      const offset = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0; // clears the fixed header
      window.scrollTo({ top: next.getBoundingClientRect().top + window.scrollY - offset, behavior: reduce ? "instant" : "smooth" });
    });
    const update = () => { hero.classList.toggle("is-scrolled", window.scrollY > 40); };
    window.addEventListener("scroll", update, { passive: true });
    update();
  })();

  // ---------- Footer link groups: collapsible below 990px, always open (and not toggleable) above ----------
  (() => {
    const groups = $$("[data-ft-group]");
    if (!groups.length) return;
    const desktop = matchMedia("(min-width: 990px)");
    const sync = () => groups.forEach(g => { g.open = desktop.matches; });
    groups.forEach(g => g.querySelector("summary")?.addEventListener("click", e => { if (desktop.matches) e.preventDefault(); }));
    desktop.addEventListener ? desktop.addEventListener("change", sync) : desktop.addListener(sync);
    sync();
  })();

  // ---------- Gentle parallax on hero / feature media ----------
  (() => {
    const els = $$(".hero .media, .feature .media");
    if (!els.length || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let ticking = false;
    const update = () => {
      els.forEach(el => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        el.style.setProperty("--py", `${(r.top + r.height / 2 - innerHeight / 2) * -0.08}px`);
      });
      ticking = false;
    };
    window.addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener("resize", update);
    update();
  })();

  // ---------- Scroll-driven color story + left progress line ----------
  // Scroll depth drives the logo color (red -> pink) and the left progress line. The page background stays a fixed bone canvas.
  (() => {
    if (body.dataset.scrollTint !== "true" && !$("#progress")) return;
    const root = document.documentElement;
    const hex = (h, fb) => { const m = /^#?([0-9a-f]{6})$/i.exec((h || "").trim()); return m ? [0, 2, 4].map(i => parseInt(m[1].slice(i, i + 2), 16)) : fb; };
    const cssVar = n => getComputedStyle(root).getPropertyValue(n).trim();
    const RED = hex(cssVar("--logo-red"), [200, 32, 43]);
    const PINK = hex(body.dataset.tintLogo, [232, 70, 142]);
    const PAROS_RED = [224, 18, 45], PAROS_PINK = [242, 96, 164], OLIVE_DK = [125, 133, 82];
    const tint = body.dataset.scrollTint === "true";
    const mix = (A, B, t) => `rgb(${A.map((v, i) => Math.round(v + (B[i] - v) * t)).join(",")})`;
    const maxScroll = () => Math.max(1, root.scrollHeight - window.innerHeight);
    const set = (n, v) => root.style.setProperty(n, v);

    function paint() {
      const p = clamp(window.scrollY / maxScroll()), t = clamp(p / 0.9);
      if (tint) {
        set("--logo-color", mix(RED, PINK, t));
        set("--paros-color", mix(PAROS_RED, PAROS_PINK, t));
      }
      set("--p", `${(p * 100).toFixed(2)}%`);
      set("--fill", p < 0.5 ? mix(RED, OLIVE_DK, p * 2) : mix(OLIVE_DK, PINK, (p - 0.5) * 2));
    }
    window.addEventListener("scroll", paint, { passive: true });
    window.addEventListener("resize", paint);
    paint();

    const bar = $("#progress");
    if (!bar) return;
    const seek = e => { const r = bar.getBoundingClientRect(); window.scrollTo({ top: clamp((e.clientY - r.top) / r.height) * maxScroll(), behavior: "instant" }); };
    let dragging = false;
    bar.addEventListener("pointerdown", e => { dragging = true; bar.setPointerCapture(e.pointerId); seek(e); });
    bar.addEventListener("pointermove", e => { if (dragging) seek(e); });
    bar.addEventListener("pointerup", () => { dragging = false; });
    bar.addEventListener("pointercancel", () => { dragging = false; });
  })();

  // ---------- Image fade-in: images still loading fade in when ready (no pop-in) ----------
  (() => {
    $$(".card__img img, .slide img, .duo__item .media, .feature .media").forEach(img => {
      if (img.complete && img.naturalWidth) return;
      img.dataset.fade = "pending";
      const done = () => { delete img.dataset.fade; };
      img.addEventListener("load", done, { once: true });
      img.addEventListener("error", done, { once: true });
    });
  })();

  refreshCart();
})();

